module.exports = __webpack_public_path__ + "img/FR App book LLL 16.9.2019-min.1a8191c9.png";